import Page from "../webPage/Page";
import {handleScrollingSection} from "util/scrolling-section";

Page.register('page-template-about', () => {
    handleScrollingSection($('.js-scrolling-logos'));
});

